import AppleIcon from "@mui/icons-material/Apple";
import ShopOutlinedIcon from "@mui/icons-material/ShopOutlined";
import { Divider, Stack } from "@mui/material";
import {
    ArrayInput,
    ArrayInputProps,
    required,
    SelectInput,
    SimpleFormIterator,
    TextInput,
    useRecordContext,
} from "react-admin";

const STORE_CHOICES = [
    { id: "app_store", name: "App Store" },
    { id: "play_store", name: "Play Store" },
];

const STORE_ICONS: Record<string, typeof AppleIcon> = {
    app_store: AppleIcon,
    play_store: ShopOutlinedIcon,
};

const StoreChoiceOption = () => {
    const record = useRecordContext<{ id: string; name: string }>();
    if (!record) {
        return null;
    }

    const Icon = STORE_ICONS[record.id];

    return (
        <Stack direction="row" alignItems="center" spacing={1}>
            {Icon && <Icon fontSize="small" sx={{ color: "text.secondary" }} />}
            <span>{record.name}</span>
        </Stack>
    );
};

export const StoreRefsInput = (props: Pick<ArrayInputProps, "source">) => (
    <>
        <Divider textAlign="left">Store SKUs</Divider>
        <ArrayInput {...props} label={false}>
            <SimpleFormIterator sx={{
                '& .RaSimpleFormIterator-line': {
                    borderBottom: 'none',
                },

            }}>
                <Stack direction="row" spacing={2} sx={{ width: "100%" }}>
                    <SelectInput
                        source="store"
                        choices={STORE_CHOICES}
                        optionText={<StoreChoiceOption />}
                        translateChoice={false}
                        validate={required()}
                        sx={{ minWidth: 160 }}
                    />
                    <TextInput
                        source="sku"
                        validate={required()}
                        fullWidth
                    />
                </Stack>
            </SimpleFormIterator>
        </ArrayInput>
    </>
);
